import { render, staticRenderFns } from "./BloodSugarLevelTab.vue?vue&type=template&id=3c3fa7bc&"
import script from "./BloodSugarLevelTab.vue?vue&type=script&lang=ts&"
export * from "./BloodSugarLevelTab.vue?vue&type=script&lang=ts&"
import style0 from "./BloodSugarLevelTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports